import axios from 'axios';
import RestService from '../../../helpers/RestService';


axios.defaults.headers.common = {
  'Accept': 'application/json, text/plain',
  'X-CSRF-Token': RestService.getCsrfToken(),
  'X-Requested-With' : 'XMLHttpRequest',
};

axios.defaults.headers.post['Content-Type'] = 'application/json';

export async function getPlans() {
  try {
    const {data} = await axios.get('/api/plans/get');
    if(data.errcode == 200) {
      return data.payload;
    } else {
      return Promise.reject({message: 'Bag request'})
    }
  } catch (error) {
    return Promise.reject({message: 'Bag request'})
  }
}


export async function createPlan(body) {
  try {
    const {data} = await axios.post('/api/plan/post', body);
    if(data.errcode == 200) {
      return data.payload;
    } else {
      return Promise.reject({message: 'Bag request'})
    }
  } catch (error) {
    return Promise.reject({message: 'Bag request'})
  }
}


export async function updatePlan(body) {
  try {
    const {data} = await axios.post('/api/plan/patch', body);
    if(data.errcode == 200) {
      return data.payload;
    } else {
      return Promise.reject({message: 'Bag request'})
    }
  } catch (error) {
    return Promise.reject({message: 'Bag request'})
  }
}




export async function deletePlan(body) {
  try {
    const {data} = await axios.post('/api/plan/delete', body);
    if(data.errcode == 200) {
      return data.payload;
    } else {
      return Promise.reject({message: 'Bag request'})
    }
  } catch (error) {
    return Promise.reject({message: 'Bag request'})
  }
}


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/AdminPanel/Plans/actions.js